export default __webpack_public_path__ + "static/y-combinator-02b915ddd51d5067ff7139cb96205342.svg";